import usePermissions from "hooks/usePermissions";
import useAIConfiguration from "ai/hooks/useAIConfiguration";
import useConfiguredModelProviders from "ai-management/model-providers/hooks/useConfiguredModelProviders";
import { modelProviderIssue } from "ai-management/utils";
const useAIFeaturesStatus = () => {
  const { isPermitted } = usePermissions();
  const canReadAIConfiguration = isPermitted("llm_provider:read");
  const canReadModelProviders = isPermitted("llm_provider:edit");
  const {
    data: { isEnabled },
    isLoading: isLoadingAIConfiguration
  } = useAIConfiguration({ enabled: canReadAIConfiguration });
  const { data: providers, isLoading: isLoadingProviders } = useConfiguredModelProviders({
    enabled: canReadModelProviders
  });
  const isLoading = isLoadingAIConfiguration || isLoadingProviders;
  return {
    aiDisabled: canReadAIConfiguration && !isLoading && !isEnabled,
    modelProviderIssue: canReadModelProviders && !isLoading ? modelProviderIssue(providers) : void 0
  };
};
export default useAIFeaturesStatus;
